import { useEffect, useRef } from 'react';

import { BottomSheetRef } from '../FilterDrawerV2/BottomSheet';

import { useDrawerState } from './useDrawerState';

export function useOpenMobileCartDrawerRef() {
  const sheetRef = useRef<BottomSheetRef>(null);
  const [isDrawerOpen] = useDrawerState();

  useEffect(() => {
    if (!isDrawerOpen && sheetRef.current?.isOpened) {
      sheetRef.current?.close();
    }
    if (isDrawerOpen && !sheetRef.current?.isOpened) {
      sheetRef.current?.open();
    }
  }, [isDrawerOpen]);

  return sheetRef;
}
